// Backend timestamps are UTC, often without a "Z" ("2026-10-21T01:30:00"); a bare date ("2026-10-21") is a UTC
// date too. Read them as UTC and show them in the viewer's own time zone — the same job shows the same day for
// everyone in the same time zone.
export function utcDate(value) {
  if (!value) return null;
  if (value instanceof Date) return value;
  const s = String(value);
  const iso = /^\d{4}-\d{2}-\d{2}$/.test(s) ? `${s}T00:00:00Z` : (/[zZ]|[+-]\d{2}:?\d{2}$/.test(s) ? s : `${s}Z`);
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? null : d;
}

export function formatDate(value) {
  const d = utcDate(value);
  return d ? d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : '—';
}

// Sort key (newest first: b - a)
export const dateValue = (value) => { const d = utcDate(value); return d ? d.getTime() : 0; };
